// @flow
import React from 'react';
import PropTypes from 'prop-types';
import LinkSectionLink from './link';
import AssetModel from 'Stores/AssetModel';
import classNames from 'classnames/bind';
import styles from './styles.scss';

const cx = classNames.bind(styles);

const LinkSection = ({ items = [{}], background = 'light', onOpenContact }) => {
  const rootClass = cx('section', {
    [background]: true,
  });

  const linkSectionItems = items.reduce((acc, item) => {
    if (item.hidden) {
      return acc;
    }

    return [...acc, { ...item, image: new AssetModel(item.image) }];
  }, []);

  if (linkSectionItems.length === 0) {
    return null;
  }

  const showInTwoLines = linkSectionItems.length > 4;

  const indexOfNewLineStart = () => {
    if (showInTwoLines) {
      return Math.ceil(linkSectionItems.length / 2);
    }

    return linkSectionItems.length;
  };

  return (
    <>
      <div className={rootClass}>
        {linkSectionItems.slice(0, indexOfNewLineStart()).map((item, i) => (
          <LinkSectionLink key={i} {...item} onOpenContact={onOpenContact} />
        ))}
      </div>

      {showInTwoLines && (
        <div className={rootClass}>
          {linkSectionItems.slice(indexOfNewLineStart(), linkSectionItems.length).map((item, i) => (
            <LinkSectionLink key={i} {...item} onOpenContact={onOpenContact} />
          ))}
        </div>
      )}
    </>
  );
};

LinkSection.propTypes = {
  items: PropTypes.arrayOf(Object),
  background: PropTypes.string,
  onOpenContact: PropTypes.func,
  deeplinkId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default LinkSection;
